import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
let mm = gsap.matchMedia();

export class HomeCTABoldParallaxFeature {
  private element: HTMLElement;
  private imageWrap: HTMLElement | null;
  private textWrap: HTMLElement | null;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.imageWrap = this.element.querySelector(".call-to-action__media");
      this.textWrap = this.element.querySelector(
        ".call-to-action__content-wrap",
      );
      this.init();
    }
  }

  private init() {
    this.animateImage();
    this.animateTextBox();
  }

  private animateImage() {
    mm.add(
      {
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)",
      },
      (context) => {
        const { isMobile = false, isDesktop = false } =
          context.conditions || {};
        gsap.from(this.imageWrap, {
          scrollTrigger: {
            trigger: this.imageWrap,
            markers: false,
            start: "top bottom",
            scrub: true,
          },
          opacity: isMobile ? 1 : 0.3,
          xPercent: isMobile ? 0 : -10,
          yoyo: true,
        });
      },
    );
  }
  private animateTextBox() {
    mm.add(
      {
        isMobile: "(max-width: 903px)",
        isDesktop: "(min-width: 904px)",
      },
      (context) => {
        const { isMobile = false, isDesktop = false } =
          context.conditions || {};
        const animationProps: any = {
          scrollTrigger: {
            trigger: this.textWrap,
            markers: false,
            start: "top bottom",
            scrub: true,
          },
          opacity: isMobile ? 1 : 0.3,
          yoyo: true,
        };

        if (!isMobile) {
          animationProps.backgroundColor = "red";
        }

        gsap.from(this.textWrap, animationProps);
      },
    );
  }
}

export class HomeCTADramaticParallaxFeature {
  private element: HTMLElement;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.init();
    }
  }

  private init() {
    this.animateImages();
    this.animateAfterLine();
  }

  private animateImages() {
    mm.add(
      {
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)",
      },
      (context) => {
        const { isMobile = false, isDesktop = false } =
          context.conditions || {};
        gsap.from(this.element, {
          scrollTrigger: {
            trigger: this.element,
            markers: false,
            start: "top bottom",
            scrub: true,
          },
          y: isMobile ? 0 : (index) => -(150 + index * 100),
          yoyo: true,
        });
      },
    );
  }

  private animateAfterLine() {
    gsap.from(this.element, {
      scrollTrigger: {
        trigger: this.element,
        markers: false,
        start: "top bottom",
        scrub: true,
      },
      "--call-to-action__content-wrap-after-scale": 0,
    });
  }
}

export class HomeSectionTitleParallaxFeature {
  private element: HTMLElement;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.init();
    }
  }

  private init() {
    console.log(this.element);
    this.animateText();
    this.animateLine();
  }

  private animateText() {
    mm.add(
      {
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)",
      },
      (context) => {
        const { isMobile = false, isDesktop = false } =
          context.conditions || {};
        gsap.from(this.element, {
          scrollTrigger: {
            trigger: this.element,
            markers: false,
            start: "top bottom",
            scrub: true,
          },
          y: isMobile ? 0 : 100,
          yoyo: true,
        });
      },
    );
  }
  private animateLine() {
    gsap.from(this.element, {
      scrollTrigger: {
        trigger: this.element,
        markers: false,
        start: "top bottom",
        scrub: true,
      },
      "--home-section-title-after-opacity": 0,
    });
  }
}

export class HomeEOPCTADramaticParallaxFeature {
  private element: HTMLElement;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.init();
    }
  }

  private init() {
    this.animateImages();
  }

  private animateImages() {
    mm.add(
      {
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)",
      },
      (context) => {
        const { isMobile = false, isDesktop = false } =
          context.conditions || {};
        gsap.from(this.element, {
          scrollTrigger: {
            trigger: this.element,
            markers: false,
            start: "top bottom",
            scrub: true,
          },
          y: isMobile ? 0 : (index) => -(150 + index * 100),
          yoyo: true,
        });
      },
    );
  }
}

export default function homeInit() {
  const homeCTADramaticParallaxFeature = document.querySelector(
    "body:has(.home-hero) .call-to-action--dramatic .call-to-action__content-wrap",
  ) as HTMLElement;

  new HomeCTADramaticParallaxFeature(homeCTADramaticParallaxFeature);

  const homeCTABoldParallaxFeatures = document.querySelectorAll(
    "body:has(.home-hero) .call-to-action--bold",
  ) as NodeListOf<HTMLElement>;

  for (let i = 0; i < homeCTABoldParallaxFeatures.length; i++) {
    new HomeCTABoldParallaxFeature(homeCTABoldParallaxFeatures[i]);
  }

  const HomeSectionTitleParallaxFeatures = document.querySelectorAll(
    "body:has(.home-hero) .home-section__title",
  ) as NodeListOf<HTMLElement>;

  for (let i = 0; i < HomeSectionTitleParallaxFeatures.length; i++) {
    new HomeSectionTitleParallaxFeature(HomeSectionTitleParallaxFeatures[i]);
  }

  const homeEOPCTADramaticParallaxFeature = document.querySelector(
    "body:has(.home-hero) .end-of-page-call-to-action--dramatic .end-of-page-call-to-action__text-wrap",
  ) as HTMLElement;

  new HomeEOPCTADramaticParallaxFeature(homeEOPCTADramaticParallaxFeature);
}
